<template>
    <b-modal
        :hide-footer="true"
        :title="$t('Upload de arquivos')"
        centered
        id="modal-suporte-upload"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        size="xl"
        @hidden="$emit('completed')"
    >
        <div class="modal-body px-0">
            <div class="row">
                <dashboard
                    class="col-12"
                    :uppy="uppy"
                    :plugins="[
                        'Webcam',
                        // 'GoogleDrive',
                        // 'Dropbox',
                        // 'Instagram',
                        // 'Facebook',
                        // 'OneDrive',
                        // 'Zoom',
                        // 'Unsplash',
                        // 'Box',
                        'ImageEditor',
                        // 'Url',
                        'Audio',
                        'ScreenCapture',
                        'DragDrop',
                        'ThumbnailGenerator',
                        // 'Tus',
                        // 'DropTarget',
                        // 'GoldenRetriever',
                        // 'Compressor',
                        // 'ProgressBar',
                    ]"
                    :props="{ theme: 'light' }"
                />
                <div class="UppyProgressBar"></div>
            </div>
        </div>
    </b-modal>
</template>
<script>
import { Dashboard } from "@uppy/vue";

import Uppy from "@uppy/core";
import Webcam from "@uppy/webcam";
import GoogleDrive from "@uppy/google-drive";
import Dropbox from "@uppy/dropbox";
import Instagram from "@uppy/instagram";
import Facebook from "@uppy/facebook";
import OneDrive from "@uppy/onedrive";
import Zoom from "@uppy/zoom";
import Unsplash from "@uppy/unsplash";
import Box from "@uppy/box";
import ImageEditor from "@uppy/image-editor";
import Url from "@uppy/url";
import Audio from "@uppy/audio";
import ScreenCapture from "@uppy/screen-capture";
import Tus from "@uppy/tus";
import DropTarget from "@uppy/drop-target";
import GoldenRetriever from "@uppy/golden-retriever";
import Compressor from "@uppy/compressor";
import FileInput from "@uppy/file-input";
import XHRUpload from "@uppy/xhr-upload";
import ProgressBar from "@uppy/progress-bar";
import DragDrop from "@uppy/drag-drop";
import DefaultStore from "@uppy/store-default";
import Portuguese from "@uppy/locales/lib/pt_BR";
import ThumbnailGenerator from "@uppy/thumbnail-generator";

import "@uppy/core/dist/style.css";
import "@uppy/dashboard/dist/style.css";
import "@uppy/webcam/dist/style.css";
import "@uppy/image-editor/dist/style.css";
import "@uppy/progress-bar/dist/style.css";
import "@uppy/screen-capture/dist/style.css";
import "@uppy/audio/dist/style.css";
import "@uppy/drag-drop/dist/style.css";
// Dropzone.autoDiscover = false;
export default {
    components: { Dashboard },
    props: ["support", "path", "pathRoot"],
    data() {
        return {
            nome: "",
            error: "",
            loading: false,
            files: "",
            self: this,
            progressCompleted: 0,
            urlbase: window.urlbase,
            classShow: "",
            headers: { "x-csrf-token": window.csrftoken },
            open: false,
        };
    },
    computed: {
        uppy: () =>
            new Uppy({
                id: "uppy",
                autoProceed: false,
                allowMultipleUploadBatches: true,
                debug: true,
                restrictions: {
                    maxFileSize: null,
                    minFileSize: null,
                    maxTotalFileSize: null,
                    maxNumberOfFiles: null,
                    minNumberOfFiles: null,
                    allowedFileTypes: null,
                    requiredMetaFields: [],
                },
                meta: { teste: "ss", item: "support" },

                locale: Portuguese,
                store: new DefaultStore(),
                infoTimeout: 5000,
                onBeforeUpload: (files) => {
                    const updatedFiles = {};
                    Object.keys(files).forEach((fileID) => {
                        //console.log(fileID);
                        updatedFiles[fileID] = {
                            ...files[fileID],
                            name: files[fileID].name,
                        };
                    });
                    return updatedFiles;
                },
            })

                .use(DragDrop, { target: null })
                .use(Webcam)
                .use(ThumbnailGenerator, {
                    thumbnailWidth: 200,
                    thumbnailHeight: 200,
                    thumbnailType: "image/jpeg",
                    waitForThumbnailsBeforeUpload: false,
                })
                .use(ImageEditor, {
                    id: "ImageEditor",
                    quality: 0.8,
                    cropperOptions: {
                        viewMode: 1,
                        background: false,
                        autoCropArea: 1,
                        responsive: true,
                        croppedCanvasOptions: {},
                    },
                    actions: {
                        revert: true,
                        rotate: true,
                        granularRotate: true,
                        flip: true,
                        zoomIn: true,
                        zoomOut: true,
                        cropSquare: true,
                        cropWidescreen: true,
                        cropWidescreenVertical: true,
                    },
                })
                .use(Audio)
                .use(ScreenCapture, {
                    displayMediaConstraints: {
                        video: {
                            width: 1280,
                            height: 720,
                            frameRate: {
                                ideal: 3,
                                max: 5,
                            },
                            cursor: "motion",
                            displaySurface: "monitor",
                        },
                    },
                    userMediaConstraints: {
                        audio: true,
                    },
                    preferredVideoMimeType: "video/mp4",
                })
                .use(Compressor)
                .use(FileInput, {
                    target: null,
                    pretty: true,
                    inputName: "files[]",
                })
                .use(XHRUpload, {
                    endpoint: `${window.urlbase}api/dashboard/support/upload`,
                    formData: true,
                    fieldName: "files[]",
                    metaFields: ["support_id"],
                    headers: {
                        Authorization:
                            window.axios.defaults.headers.common.Authorization,
                        ContentType: "multipart/form-data",
                    },
                })
                .on("upload-success", (file, response) => {
                    // //console.log(window);
                    // //console.log(window.Vue);
                    // //console.log(window.Vue.$options);
                    // window.Vue.$emit("completed", window.pathCurrent);
                    // window.Vue.$emit("completed");
                    // do something with file and response
                })
                .on("file-added", (file) => {
                    //console.log(file);
                    //console.log("file-added");
                    //console.log(window.supportId);
                    //console.log("file-added-end");
                    uppy.setFileMeta(file.id, {
                        support_id: window.supportId,
                    });
                }),
    },
    mounted() {
        window.Vue = this;
        // this.uppy.on("upload-success", (file, response) => {
        //     const url = response.uploadURL;
        //     const fileName = file.name;
        //     const li = document.createElement("li");
        //     const a = document.createElement("a");
        //     a.href = url;
        //     a.target = "_blank";
        //     a.appendChild(document.createTextNode(fileName));
        //     li.appendChild(a);
        //     document.querySelector(".uploaded-files ol").appendChild(li);
        // });
    },
    methods: {
        uploadSuccess(file) {
            this.$emit("upload", this.path);
            this.$refs.myVueDropzone.removeFile(file);
        },
        sendingEvent(file, xhr, formData) {
            formData.append("path", this.path);
        },
        submitFile(files) {
            this.files = files;
        },
        submit(files) {
            this.files = files;
            this.loading = true;
            this.error = null;
            let formData = new FormData();

            if (this.files.length > 0 && this.files.length != undefined) {
                for (const i of Object.keys(this.files)) {
                    formData.append("files[]", this.files[i]);
                }
            } else {
                formData.append("files", this.files);
            }

            formData.append("caminho", this.path);
            formData.append("caminho_root", this.pathRoot);
            if (this.item) {
                formData.append("id", this.item.id);
            }

            axios
                .post(`api/dashboard/documento/upload`, formData, {
                    header: { "Content-Type": "multipart/form-data" },
                    onUploadProgress: (event) => {
                        let progress = Math.round(
                            (event.loaded * 100) / event.total
                        );
                        this.progressCompleted = progress;
                    },
                })
                .then((response) => {
                    if (response.data.error) {
                        this.error = response.data.error;
                    } else {
                        this.$emit("upload-completed", this.path);
                        this.error = null;
                        this.nome = "";
                    }
                })
                .finally(() => {
                    this.$emit("completed");
                    this.progressCompleted = 0;
                    this.files = [];
                    this.$bvModal.hide("upload");
                    this.loading = false;
                });
        },

        // function where we get the upload progress
        uploadProgress(file, progress, bytesSent) {
            //console.log("File Upload Progress", progress);
            this.tempAttachments.map((attachment) => {
                if (attachment.title === file.name) {
                    attachment.progress = `${Math.floor(progress)}`;
                }
            });
        },
        // called on successful upload of a file
        success(file, response) {
            //console.log("File uploaded successfully");
            //console.log("Response is ->", response);
        },
    },
};
</script>
<style lang="css">
.vue-dropzone {
    border: 1.8px dashed #2f63b8 !important;
    padding: 10px !important;
}
.uppy-Dashboard-inner {
    width: 100% !important;
}
.uppy-Dashboard-AddFiles-info {
    display: none !important;
}
</style>
